import { Route } from "react-router-dom";
import { AuthenticationGuard } from "@/components/AuthenticationGuard/AuthenticationGuard";
import MainLayout from "@/components/MainLayout/MainLayout";
import PermissionGuard from "@/components/PermissionGuard/PermissionGuard";
import DashboardPage from "@/modules/stochastic/features/Reports/SCDashboard/components/DashboardPage/DashboardPage";
import MemberDashboardPage from "@/modules/hub/features/MemberDashboard/components/MemberDashboardPage/MemberDashboardPage";
import TotalAddressableMarketPage from "@/modules/stochastic/features/TotalAddressableMarket/components/TotalAddressableMarketPage/TotalAddressableMarketPage";
import MonthlyBalanceSheet from "@/modules/hub/features/FinancialReports/components/MonthlyBalanceSheet/MonthlyBalanceSheet";
import ProfitAndLoss from "@/modules/hub/features/FinancialReports/components/ProfitAndLoss/ProfitAndLoss";
import ProfitAndLossBuilder from "@/modules/hub/features/FinancialReports/components/ProfitAndLossBuilder/ProfitAndLossBuilder";
import TransactionList from "@/modules/hub/features/FinancialReports/components/TransactionList/TransactionList";

const DashboardsMainLayout = () => <MainLayout section="dashboards" />;

/**
 * The Business Intelligence section: member-facing analytics dashboards and
 * the financial reports under their own app-strip section and layout. The
 * pages are the same components the old locations rendered — only the routes
 * and the surrounding section moved. Total Addressable Market also remains
 * reachable at its original Lead Generation URL (deliberate duplicate; see
 * dashboardsNavigation).
 */
const DashboardsRoutes = (
  <Route
    element={<AuthenticationGuard component={DashboardsMainLayout} />}
    path="/business-intelligence"
  >
    <Route
      element={
        <PermissionGuard requiredPermissions={["stochastic-dashboard"]}>
          <DashboardPage />
        </PermissionGuard>
      }
      path="sales-and-customer-dashboard"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["kpi-dashboard"]}>
          <MemberDashboardPage />
        </PermissionGuard>
      }
      path="kpi-dashboard"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["stochastic-total-addressable-market"]}
        >
          <TotalAddressableMarketPage />
        </PermissionGuard>
      }
      path="total-addressable-market"
    />

    {/* Financial Reports routes */}
    <Route
      element={
        <PermissionGuard
          requiredPermissions={["financial-reports-monthly-balance"]}
        >
          <MonthlyBalanceSheet />
        </PermissionGuard>
      }
      path="financial-reports/monthly-balance-sheet"
    />
    <Route
      element={
        <PermissionGuard
          requiredPermissions={["financial-reports-profit-and-loss"]}
        >
          <ProfitAndLoss />
        </PermissionGuard>
      }
      path="financial-reports/profit-and-loss"
    />
    <Route
      element={
        <PermissionGuard
          requiredPermissions={["financial-reports-p-and-l-report-builder"]}
        >
          <ProfitAndLossBuilder />
        </PermissionGuard>
      }
      path="financial-reports/profit-and-loss-builder"
    />
    <Route
      element={
        <PermissionGuard
          requiredPermissions={["financial-reports-transaction-list"]}
        >
          <TransactionList />
        </PermissionGuard>
      }
      path="financial-reports/transaction-list"
    />
  </Route>
);

export default DashboardsRoutes;
